import { Capacitor, SystemBars, SystemBarType } from '@capacitor/core';

/**
 * Politique unique de l'application : mode immersif total.
 * Status bar masquée (iOS + Android) et barre de navigation masquée (Android),
 * sur tous les écrans — aucun style de status bar par page.
 */
export const enableImmersiveMode = async () => {
    if (!Capacitor.isNativePlatform()) {
        return;
    }

    try {
        await SystemBars.hide({ bar: SystemBarType.StatusBar });
        if (Capacitor.getPlatform() === 'android') {
            await SystemBars.hide({ bar: SystemBarType.NavigationBar });
        }
    } catch (error) {
        console.error('Error enabling immersive mode:', error);
    }
};

/**
 * Définit la couleur de fond de la safe area (zones d'encoche/cutout,
 * toujours présentes même barres masquées)
 * @param color - Couleur CSS valide (hex, rgb, rgba, gradient, etc.)
 */
export const setSafeAreaBackgroundColor = (color: string) => {
    document.documentElement.style.setProperty('--safe-area-bg-color', color);
};
